<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card :title="pageTitle">
      <BaseForm
        ref="baseForm"
        @getOtherFormVal="getOtherFormVal"
        @getRechargeAccount="getRechargeAccount"
      />
      <Receipt ref="receipt" @getOtherFormVal="getOtherFormVal" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import Receipt from './receipt';
import SubBtnBox from 'components/subBtnBox';
import {
  manageEdit,
  manageDetail,
} from 'api/cost';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    Receipt,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/cost/manage/feeEdit',
      formComponents: ['baseForm', 'receipt'],

      subLoading: false,
      // 需要对比的参数
      compareParams: {
        payType: '',
        applyOrgId: '',
        isNeedBill: '',
        feeAscriptionDate: '',
        payAmt: '',
        etcTrafficFee: '',
        etcServiceFee: '',
        etcLateFee: '',
        principal: '',
        interest: '',
        payRemark: '',
        fileId: [],

        // 这个不知道判断逻辑是什么，暂时不判断
        receUserId: '',
        selectedLIds: '',
      },
    };
  },
  computed: {
    detailParams () {
      return {
        payId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: manageDetail,
    editApi: manageEdit,

    // 处理对比参数
    adjustCompareParams (compareParams) {
      compareParams.orgId = compareParams.applyOrgId;

      compareParams.feeAscriptionDate = this.formatDate(compareParams.feeAscriptionDate, 1);

      if (compareParams.fileId.length) {
        compareParams.fileId = compareParams.fileId.join(',');
      } else {
        compareParams.fileId = '';
      }

      if (Array.isArray(compareParams.selectedLIds)) {
        if (compareParams.selectedLIds.length) {
          // 这个不知道判断逻辑是什么，暂时不判断
        } else {
          compareParams.selectedLIds = '[]';
        }
      }
    },
    async getOtherFormVal ({ from, tar }) {
      const tarFormData = await this.$refs[tar].cacheData();
      this.$refs[from].receiveData(tar, tarFormData);
    },
    getRechargeAccount () {
      this.$refs.receipt.getRechargeAccount();
    },
  },
  async mounted () {
    if (this.$route.path === this.pageUrl) {
      await this.$refs.baseForm.getList(this.$route.query.subjectsType);
      this.getData();
    }
  },
};
</script>

<style scoped lang="scss">
</style>
